<template>
  <v-app>
    <v-app-bar app :color="this.$store.getters.stdColorLight" height="80">
      <v-container fluid>
        <v-row align="center">
          <v-col cols="9">
            <router-view :name="this.$store.getters.routerViewToolbar"></router-view>
          </v-col>
          <v-spacer></v-spacer>
          <v-menu
            v-model="value"
            :disabled="disabled"
            :absolute="absolute"
            :open-on-hover="openOnHover"
            :close-on-click="closeOnClick"
            :close-on-content-click="closeOnContentClick"
            :offset-x="offsetX"
            :offset-y="offsetY"
          >
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(lang, index) in langs"
                :key="index"
                @click="handleLanguage(lang.locale)"
              >
                <v-list-item-title>{{ lang.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <router-view :name="this.$store.getters.routerViewContent"></router-view>
    </v-main>
  </v-app>
</template>

<script>
//import Sdb from "./components/Sdb";
//import colors from 'vuetify/lib/util/colors'
import LoggerHelper from "@/plugins/LoggerHelper";

export default {
  name: "App",
  /* components: {
    Sdb
  },*/

  data: () => ({
    //languages, menu
    langs: [
      { locale: "de", title: "deutsch" },
      { locale: "fr", title: "französisch" },
      { locale: "en", title: "englisch" }
    ],
    disabled: false,
    absolute: false,
    openOnHover: false,
    value: false,
    closeOnClick: true,
    closeOnContentClick: true,
    offsetX: false,
    offsetY: true,
  }),

  created() {
    LoggerHelper.initLogger(this);
  },

  mounted() {
    //this.$vuetify.theme.dark=false
  },

  methods: {
    handleLanguage: function(aLocale) {
      this.$root.$i18n.locale = aLocale;
      //force watch to be executed
      this.$store.dispatch("setSelectedLanguage", aLocale);
      this.$store.dispatch("setIsArtikel", true);
      this.$store.dispatch("setSelectionValue", null);
      this.$store.dispatch("setSdbLanguageCountrys", []);
    }
  }
};
</script>
